export default "__VITE_ASSET__esIWP4s0__"